<template>
  <div>
    <div class="image-container border mb-1">
      <b-img :src="imageUrl || defaultImage" fluid alt="Responsive image"></b-img>
      <button v-if="file" @click="removeImage" class="remove-button">[x]</button>
    </div>
    <br>
    <input v-if="!file" class="mb-1" type="file" @change="handleFileUpload" accept="image/*" />
    <br>
  </div>
</template>

<script>
import axios from 'axios';
import fetchClient from '@/fetchClient';
export default {
  props: {
    value: File,  // v-model để liên kết với cha
    defaultImage: { // Hình ảnh mặc định
      type: String,
      default: "https://via.placeholder.com/100" // Ảnh mặc định nếu không có hình nào
    }
  },
  data() {
    return {
      file: null,
      imageUrl: this.defaultImage // Ban đầu hiển thị ảnh mặc định
    };
  },
  methods: {
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.imageUrl = URL.createObjectURL(this.file);
      this.$emit("input", this.file); // Cập nhật v-model
    },
    removeImage() {
      this.file = null;
      this.imageUrl = this.defaultImage; // Quay về ảnh mặc định
      this.$emit("input", null);
    },
    async uploadFile() {
      if (!this.file) return;

      const formData = new FormData();
      formData.append("myfile", this.file);

      let res = await fetchClient.post("/api/FileUpload2/UploadAxios?path=UploadedFiles", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });
      this.$emit("upload-done", res.data.rec.pathFull);
      this.removeImage();
    },
    async uploadFile2(file){
      const formData = new FormData()
      formData.append('image', file);
      return await fetchClient.post(`/api/FileUpload3/PostImage`,formData,{
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .catch(err=>{
        console.log(err);
      })
    },
    //post: /api/FileUpload3/PostImage2
    async uploadFile3(file){
      const formData = new FormData()
      formData.append('image', file);
      return await fetchClient.post(`/api/FileUpload3/PostImage2`,formData,{
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .catch(err=>{
        console.log(err);
      })
    },

    async Del(filename){//ok
      return await fetchClient.get(`/api/FileUpload3/Del?filename=${filename}`)
    },
  }
};
</script>

<style scoped>
.image-container {
  position: relative;
  display: inline-block;
}

.remove-button {
  position: absolute;
  top: 0;
  right: 0;
  background-color: red;
  color: white;
  border: none;
  cursor: pointer;
  padding: 5px;
}
</style>